import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditCategoryDiscount = props => {
  return (
    <Edit
      title='Edit Category Discount'
      fields={fields}
      apiPath={`admin/category_discounts/${props.params.categoryDiscountId}`}
      successRedirectPath='/ecommerce/category-discounts'
      buildMenuItems={menuItems}
    />
  )
}

export default EditCategoryDiscount
